import React from 'react'
import { Route, Routes, HashRouter } from 'react-router-dom';

import { Amplify } from 'aws-amplify'
import { Authenticator, } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'

import {
    I18n,
} from 'konekti-ex-functions'

import Page1 from './Page1'

import TopBar from './TopBar'

import { ThemeProvider } from '@mui/material/styles'
import { DerevaTheme } from './Components/Style/DerevaTheme'

const outputs = window.AmplifyOutputs

// サブタイトル設定
const subTitle = outputs.env.onpre ? `Edge for ${outputs.env.device_name}` : "DataStream"

const paths = () => {
    return {
    }
}

const routes = (
    <Routes>
        {/* 暫定でUserSettingをトップページにする */}
        <Route path="/" element={<Page1 />} />
    </Routes>
)

const Page = (): React.JSX.Element => {

    Amplify.configure(window.AmplifyOutputs)

    return (
        // 環境変数を参照して、オンプレかクラウドかを判定する
        // オンプレならAuthenticator(Cognito認証)を使わない
        outputs.env.onpre ? (
            <ThemeProvider theme={DerevaTheme}>
                <HashRouter>
                    <TopBar
                        paths={paths()}
                        color={outputs.env.color}
                    />
                    {routes}
                </HashRouter>
            </ThemeProvider>
        ) : (
            <Authenticator
                hideSignUp={true}
            >
                {({ signOut, user }) => (
                    <ThemeProvider theme={DerevaTheme}>
                        <HashRouter>
                            <TopBar
                                paths={paths()}
                                user={user}
                                onSignOut={signOut}
                            />
                            {routes}
                        </HashRouter>
                    </ThemeProvider>
                )}
            </Authenticator>
        )
    )
}

export default Page;
